import { __awaiter } from "tslib";
import { notes } from "@phoenixreisen/mithrils/src/notification";
import { fields, isValidForm } from "./form.model.fields";
import Model from "../../model";
import m from "mithril";
function submit(showSuccess, state, e) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const { address, customer } = fields;
        if (isValidForm(address)) {
            try {
                state.submitting = true;
                yield Model.save(address, customer);
                showSuccess(true);
            }
            catch (e) {
                const error = e;
                console.error(JSON.stringify(e));
                notes.add({
                    status: "error",
                    text: (_a = error === null || error === void 0 ? void 0 : error.details) !== null && _a !== void 0 ? _a : `Wir konnten Ihre Bestellung leider nicht aufnehmen.
                Bitte versuchen Sie es später noch einmal.`,
                });
            }
            finally {
                state.submitting = false;
                m.redraw();
            }
        }
    });
}
export default {
    oninit({ state }) {
        state.submitting = false;
    },
    view({ attrs, state }) {
        const address = fields.address;
        const { submitting } = state;
        const { showForm, showSuccess, nations } = attrs;
        return (m("form", { class: `form ${showForm() ? "fade-in" : "fade-out"}`, onsubmit: (e) => submit(showSuccess, state, e) },
            m("div", { class: "row row--2er" },
                m("label", { class: "select" },
                    m("select", { onchange: (e) => address.gender.validate(e.target.value) },
                        m("option", { value: "", selected: "selected" }, "Bitte ausw\u00E4hlen"),
                        m("option", { value: "Frau", selected: address.gender.value() === "Frau" }, "Frau"),
                        m("option", { value: "Herr", selected: address.gender.value() === "Herr" }, "Herr")),
                    m("span", { class: `select__label ${address.gender.complaint ? "alert--warning" : ""}` }, "Anrede*")),
                m("label", { class: "select" },
                    m("select", { onchange: (e) => address.title.validate(e.target.value) },
                        m("option", { value: "", selected: "selected" }),
                        m("option", { value: "Dr.", selected: address.title.value() === "Dr." }, "Dr."),
                        m("option", { value: "Prof.", selected: address.title.value() === "Prof." }, "Prof.")),
                    m("span", { class: "select__label" }, "Titel"))),
            m("div", { class: "row row--2er" },
                m("label", { class: "textfield" },
                    m("input", { name: "prename", autocomplete: "prename", type: "text", maxLength: "100", value: address.prename.value(), oninput: (e) => address.prename.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.prename.complaint ? "alert--warning" : ""}` }, "Vorname*")),
                m("label", { class: "textfield" },
                    m("input", { name: "surname", autocomplete: "surname", type: "text", maxLength: "100", value: address.surname.value(), oninput: (e) => address.surname.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.surname.complaint ? "alert--warning" : ""}` }, "Nachname*"))),
            m("div", { class: "row row--2er" },
                m("label", { class: "textfield" },
                    m("input", { name: "street", autocomplete: "street", type: "text", maxLength: "150", value: address.street.value(), oninput: (e) => address.street.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.street.complaint ? "alert--warning" : ""}` }, "Stra\u00DFe*")),
                m("label", { class: "textfield" },
                    m("input", { name: "house-number", autocomplete: "house-number", type: "text", maxLength: "150", value: address.houseNumber.value(), oninput: (e) => address.houseNumber.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.houseNumber.complaint ? "alert--warning" : ""}` }, "Hausnummer*"))),
            m("label", { class: "textfield" },
                m("input", { name: "address-addition", autocomplete: "address-add", type: "text", maxLength: "100", value: address.addressAddition.value(), oninput: (e) => address.addressAddition.validate(e.target.value) }),
                m("span", { class: `textfield__label ${address.addressAddition.complaint ? "alert--warning" : ""}` }, "Adresszusatz")),
            m("div", { class: "row row--2er" },
                m("label", { class: "textfield" },
                    m("input", { name: "zipcode", autocomplete: "zipcode", type: "text", maxLength: "20", value: address.zipCode.value(), oninput: (e) => address.zipCode.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.zipCode.complaint ? "alert--warning" : ""}` }, "Postleitzahl*")),
                m("label", { class: "textfield" },
                    m("input", { name: "city", autocomplete: "city", type: "text", maxLength: "100", value: address.city.value(), oninput: (e) => address.city.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${address.city.complaint ? "alert--warning" : ""}` }, "Ort*"))),
            m("label", { class: "select" },
                m("select", { onchange: (e) => address.country.validate(e.target.value) },
                    m("option", { value: "", selected: "selected" }),
                    m("optgroup", { label: "Favoriten" }, nations.fav.map((nation) => {
                        const country = address.country.value();
                        const abbr = nation["landinfo/iso-3166-alpha2"];
                        return (m("option", { value: abbr, selected: abbr === country }, nation["landinfo/name"]));
                    })),
                    m("optgroup", { label: "Alle" }, nations.all.map((nation) => {
                        const country = address.country.value();
                        const abbr = nation["landinfo/iso-3166-alpha2"];
                        return (m("option", { value: abbr, selected: abbr === country }, nation["landinfo/name"]));
                    }))),
                m("span", { class: `select__label ${address.country.complaint ? "alert--warning" : ""}` }, "Land*")),
            m("div", { class: "tr" },
                m("button", { type: "submit", disabled: submitting },
                    submitting ? m("i", { class: "fas fa-spinner fa-spin mr2" }) : "",
                    "Kostenlos bestellen"))));
    },
};
